import Styled from 'styled-components';

const Option = Styled.div<{ disable: boolean }>`
  position: relative;
  align-items: center;
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  padding: 0 16px;
  border-top: 1px solid #DFDFDF;

  > label {
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: ${({ disable }) => (disable ? '0.5' : '')};
  }

  > input {
    appearance: none;
    border: 2px solid #A9A9A9;
    width: 15px;
    height: 15px;
    border-radius: 50px;
    outline: none;
    opacity: ${({ disable }) => (disable ? '0.5' : '')};
    margin: 0;

    &:checked {
    border: 4px solid ${({ theme }) => theme.primaryColor};
    background: #ffffff;
   }
  }
`;

const Hr = Styled.hr`
border: 1px solid #DFDFDF;
`;

const Select = Styled.div`
 &:last-child {
    border-bottom: none;
  }
`;

export default Select;
export { Select, Option, Hr };
